const AppConfigDefs = {
    app: {
        abreviatura: "SIC",
        nome: "Sistema de Inteligência Comercial",
        empresa: "FarmaPlus",
        footer: "FarmaPlus - 2025"
    },
    login: {
        logo: {
            ligth: 'layout/farmaplus/images/logo-light.png',
            dark: 'layout/farmaplus/images/logo-dark.png',
            style: 'height: 72px;'
        },
        logoname: {
            ligth: 'layout/farmaplus/images/logo-nome-lightv2.png',
            dark: 'layout/farmaplus/images/logo-nome-darkv2.png',
            style: 'width: 210px;'
        }
    },
    topbar: {
        logo: {
            ligth: 'layout/farmaplus/images/logo-light.png',
            dark: 'layout/farmaplus/images/logo-dark.png',
            style: 'height:36px;'
        },
        logoname: {
            ligth: 'layout/farmaplus/images/logo-nome-light.png',
            dark: 'layout/farmaplus/images/logo-nome-dark.png',
            style: 'height:32px;'
        }
    },
    opcoes: {
        powerbi: {
            desabilitarSalvamentoAutomatico: true
        }
    },
    theme: {
        colorScheme: 'light',
        menu: 'blue',
        component: 'blue',
        menuMode: 'horizontal'
    },
    sifm: true
};

export default AppConfigDefs;